<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Cấu hình mẫu văn bản điện tử</h4>
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search">
            <el-form
              ref="searchForm"
              :model="tableRules.dataSearch.value"
              label-position="left"
              label-width="130px"
              @submit.native.prevent
            >
              <b-row>
                <b-col md="5">
                  <el-form-item label="Từ khóa">
                    <el-input
                      v-model="tableRules.dataSearch.value.keyword"
                      clearable
                      placeholder="Tìm theo tên mẫu, số/ký hiệu"
                      @keyup.enter.native="tableSearch"
                      @clear="tableSearch"
                    />
                  </el-form-item>
                </b-col>
                <b-col md="5">
                  <el-form-item label="Phân loại mẫu">
                    <el-select
                      v-model="tableRules.dataSearch.value.dda_category_id"
                      clearable
                      filterable
                      placeholder="Tất cả"
                      class="w-100"
                      @change="tableSearch"
                    >
                      <el-option
                        v-for="item in dataDefault.categories"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="2" class="text-right">
                  <el-button round class="btn-default" native-type="submit" @click="tableSearch">
                    Tìm kiếm
                  </el-button>
                  <el-button round class="btn-default" @click="handleCreate">
                    Thêm mới
                  </el-button>
                </b-col>
              </b-row>
            </el-form>
          </div>
          <div class="main-body__table mt-3">
            <el-table :data="tableRules.data" border style="width: 100%" max-height="500">
              <el-table-column label="STT" width="60" align="center">
                <template slot-scope="scope">
                  {{ tableRules.offset + scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="Tên mẫu" min-width="220" />
              <el-table-column label="Phân loại mẫu" min-width="200">
                <template slot-scope="scope">
                  {{ categoryMap[scope.row.dda_category_id] || "" }}
                </template>
              </el-table-column>
              <el-table-column label="Nội dung" min-width="300">
                <template slot-scope="scope">
                  <span class="content-summary">{{ getContentSummary(scope.row.content) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Khóa" width="70" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.disabled" @change="toggleDisabled(scope.row)" />
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" width="130" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" plain round @click="handleUpdate(scope.row.id)">
                    <i class="isax-edit"></i>
                  </el-button>
                  <el-button size="mini" plain round type="danger" @click="handleDelete(scope.row.id)">
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <b-row class="mt-2">
              <b-col md="12" class="text-right">
                <el-pagination
                  @size-change="onSizeChange"
                  @current-change="onCurrentChange"
                  :page-sizes="tableRules.lengthMenu"
                  :page-size="tableRules.limit"
                  :current-page="tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="tableRules.total"
                  :pager-count="5"
                />
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="viewMode === 'create' ? 'Thêm mới cấu hình mẫu' : 'Cập nhật mẫu cấu hình'"
      :visible.sync="visibleDialog"
      top="50px"
      width="800px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="form-dialog"
    >
      <el-form
        ref="templateForm"
        :model="dataForm"
        :rules="validForm"
        label-position="left"
        label-width="170px"
        @submit.native.prevent
      >
        <b-row>
          <b-col md="12">
            <el-form-item label="Tên mẫu" prop="name">
              <el-input v-model="dataForm.name" clearable @change="trimField('name')" />
            </el-form-item>
          </b-col>
          <b-col md="6">
            <el-form-item label="Phân loại mẫu" prop="dda_category_id">
              <el-select v-model="dataForm.dda_category_id" clearable filterable class="w-100">
                <el-option
                  v-for="item in dataDefault.categories"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </b-col>
          <b-col md="12">
            <el-form-item label="File mẫu" prop="template_file_id">
              <el-upload
                class="template-upload"
                drag
                action=""
                :auto-upload="false"
                :limit="1"
                :accept="dataDefault.templateFileAccept"
                :file-list="templateFileList"
                :on-change="handleTemplateFileChange"
                :on-remove="handleTemplateFileRemove"
                :on-exceed="handleTemplateFileExceed"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Thả file vào đây hoặc <em>click để upload</em></div>
                <div class="el-upload__tip" slot="tip">
                  Hỗ trợ doc, docx, pdf, html.
                </div>
              </el-upload>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button class="btn-back" @click="handleClose">Bỏ qua</el-button>
        <el-button type="primary" @click="submitForm">
          {{ viewMode === "create" ? "Thêm mới" : "Cập nhật" }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DataService from "@/service/DataService";
import LanguageService from "@/service/LanguageService";
import MethodService from "@/service/MethodService";
import ValidService from "@/service/ValidService";
import ExtensionService from "@/service/ExtensionService";
import ContractTemplateConfigApi from "@/moduleApi/ContractTemplateConfigApi";
import ContractTemplateCategoryApi from "@/moduleApi/ContractTemplateCategoryApi";
import DocumentCategoryApi from "@/moduleApi/DocumentCategoryApi";
import DocumentBusinessApi from "@/moduleApi/DocumentBusinessApi";
import mammoth from "mammoth";
import * as PDFJS from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

const emptyForm = {
  id: null,
  dda_category_id: null,
  name: "",
  code: "",
  description: "",
  template_file_id: null,
  template_file: null,
  content: {
    header: "",
    body: "",
    footer: "",
  },
  config: {
    margin_top: 20,
    margin_bottom: 20,
    margin_left: 30,
    margin_right: 20,
    page_size: "A4",
    page_orientation: "Portrait",
  },
  default_values: {
    name: "",
    code: "",
    book_number: "",
    document_category_name: "",
    business_name: "",
    description: "",
    urgency_id: "Bình thường",
    secret_id: "Bình thường",
    type: "INTERNAL_DOC",
    is_has_effected_after_signed: true,
  },
  disabled: false,
};

const emptyTableRules = {
  data: [],
  lengthMenu: [20, 40, 80, 120, 200, 500],
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "-created_at",
  dataSearch: {
    value: {
      keyword: "",
      dda_category_id: null,
    },
  },
};

export default {
  props: {
    templateKind: {
      type: String,
      default: "CONTRACT",
    },
  },
  data() {
    return {
      aLang: LanguageService.lang,
      visibleDialog: false,
      viewMode: "create",
      dataForm: this.getEmptyForm(),
      tableRules: MethodService.copyObject(emptyTableRules),
      templateFileList: [],
      dataDefault: {
        listDocumentOp: DataService.listDocumentOp,
        categories: [],
        documentCategories: [],
        businessList: [],
        templateFileAccept: ".doc,.docx,.pdf,.html,.htm",
      },
      validForm: {
        dda_category_id: [ValidService.requiredChange],
        name: [ValidService.required, ValidService.checkSpaceString, ValidService.checkMaxLength(255)],
        code: [ValidService.required, ValidService.checkSpaceString, ValidService.checkMaxLength(50)],
        template_file_id: [ValidService.requiredChange],
      },
    };
  },
  computed: {
    isContractScreen() {
      return this.templateKind === "CONTRACT";
    },
    screenTitle() {
      return this.isContractScreen
        ? "Cấu hình mẫu hợp đồng điện tử"
        : "Cấu hình mẫu văn bản điện tử";
    },
    categoryMap() {
      return this.dataDefault.categories.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
    },
  },
  methods: {
    getEmptyForm() {
      return {
        ...MethodService.copyObject(emptyForm),
        kind: this.templateKind,
      };
    },
    async loadCategories() {
      const res = await ContractTemplateCategoryApi.list({ limit: 1000 });
      this.dataDefault.categories = res.result || [];
    },
    async loadDocumentCategories() {
      const res = await DocumentCategoryApi.list({ limit: 1000 });
      this.dataDefault.documentCategories = res.result || [];
    },
    async loadBusinessList() {
      const res = await DocumentBusinessApi.list({ limit: 1000 });
      this.dataDefault.businessList = res.result || [];
    },
    async initTable() {
      const dataFilter = {
        keyword: this.tableRules.dataSearch.value.keyword,
        dda_category_id: this.tableRules.dataSearch.value.dda_category_id,
        limit: this.tableRules.limit,
        offset: this.tableRules.offset,
        sort: this.tableRules.sort,
      };
      const res = await ContractTemplateConfigApi.list(dataFilter);
      this.tableRules.total = res.meta ? res.meta.total : (res.result ? res.result.length : 0);
      this.tableRules.data = res.result || [];
    },
    tableSearch() {
      if (this.tableRules.dataSearch.value.keyword) {
        this.tableRules.dataSearch.value.keyword = this.tableRules.dataSearch.value.keyword.trim();
      }
      this.tableRules.offset = 0;
      this.tableRules.page = 1;
      this.initTable();
    },
    onSizeChange(limit) {
      this.tableRules.limit = limit;
      this.tableRules.page = 1;
      this.tableRules.offset = 0;
      this.initTable();
    },
    onCurrentChange(page) {
      this.tableRules.page = page;
      this.tableRules.offset = (page - 1) * this.tableRules.limit;
      this.initTable();
    },
    handleCreate() {
      this.viewMode = "create";
      this.dataForm = this.getEmptyForm();
      this.templateFileList = [];
      this.visibleDialog = true;
    },
    async handleUpdate(id) {
      const res = await ContractTemplateConfigApi.findById(id);
      if (!res.result) return;
      this.viewMode = "update";
      this.dataForm = {
        ...this.getEmptyForm(),
        ...res.result,
        content: {
          ...this.getEmptyForm().content,
          ...(res.result.content || {}),
        },
        default_values: {
          ...this.getEmptyForm().default_values,
          ...(res.result.default_values || {}),
        },
      };
      this.templateFileList = this.dataForm.template_file
        ? [
            {
              name: this.dataForm.template_file.name,
              id: this.dataForm.template_file.id,
              url: this.dataForm.template_file.url,
            },
          ]
        : [];
      this.visibleDialog = true;
    },
    handleDelete(id) {
      this.$confirm(this.aLang.c_deleteConfirm, {
        confirmButtonText: this.aLang.c_agree,
        cancelButtonText: this.aLang.c_cancel,
        type: "warning",
      }).then(async () => {
        await ContractTemplateConfigApi.delete(id);
        window.toastr.success("Xóa thành công");
        this.initTable();
      }).catch(() => {});
    },
    async toggleDisabled(row) {
      await ContractTemplateConfigApi.update({
        id: row.id,
        disabled: row.disabled,
      });
    },
    trimField(field) {
      if (this.dataForm[field]) this.dataForm[field] = this.dataForm[field].trim();
    },
    getFileExtension(fileName) {
      const parts = String(fileName || "").split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "";
    },
    async handleTemplateFileChange(file, fileList) {
      try {
        const res = await ExtensionService.upload(file, "Template_File");
        const fileId = res.result;
        
        this.dataForm.template_file_id = fileId;
        this.dataForm.template_file = {
          id: fileId,
          name: file.name,
          size: file.size,
          type: file.raw ? file.raw.type : "",
          extension: this.getFileExtension(file.name),
          url: ExtensionService.urlDowloadFile + fileId,
        };

        const nextFileList = fileList && fileList.length ? fileList.slice(-1) : [file];
        this.templateFileList = nextFileList.map((item) => ({
          ...item,
          id: fileId,
          url: ExtensionService.urlDowloadFile + fileId,
        }));

        if (!this.dataForm.name && file.name) {
          this.dataForm.name = file.name.replace(/\.[^/.]+$/, "");
        }
        
        this.scanFileToHtml(file);
        
        this.$nextTick(() => {
          if (this.$refs.templateForm) this.$refs.templateForm.validateField("template_file_id");
        });
      } catch (err) {
        console.error("Upload error:", err);
        this.templateFileList = [];
      }
    },
    async scanFileToHtml(file) {
      const extension = this.getFileExtension(file.name);
      if (!file.raw) return;
      try {
        if (extension === "docx") {
          const arrayBuffer = await this.readFileAsArrayBuffer(file.raw);
          const result = await mammoth.convertToHtml({ arrayBuffer });
          this.dataForm.content.body = result.value;
        } else if (extension === "pdf") {
          await this.scanPdfToHtml(file);
        } else if (extension === "html" || extension === "htm") {
          const text = await this.readFileAsText(file.raw);
          this.dataForm.content.body = text;
        }
      } catch (err) {
        console.error("Scan error:", err);
      }
    },
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsArrayBuffer(file);
      });
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsText(file);
      });
    },
    async scanPdfToHtml(file) {
      try {
        PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        const arrayBuffer = await this.readFileAsArrayBuffer(file.raw);
        const loadingTask = PDFJS.getDocument({ data: arrayBuffer });
        const pdf = await loadingTask.promise;
        let fullHtml = "";
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();
          let lastX = -1;
          let lastY = -1;
          let lastWidth = 0;
          let pageHtml = "";
          for (const item of textContent.items) {
            const x = item.transform[4];
            const y = item.transform[5];
            
            if (lastY !== -1 && Math.abs(lastY - y) > 5) {
              pageHtml += "<br/>";
            } else if (lastX !== -1) {
              const gap = x - (lastX + lastWidth);
              if (gap > 1.5) { 
                pageHtml += " ";
              }
            }
            
            pageHtml += item.str;
            lastX = x;
            lastY = y;
            lastWidth = item.width || 0;
          }
          fullHtml += `<div style="margin-bottom: 20px;">${pageHtml}</div>`;
        }
        this.dataForm.content.body = `<div>${fullHtml}</div>`;
      } catch (err) {
        console.error("PDF scan error:", err);
      }
    },
    handleTemplateFileRemove() {
      this.dataForm.template_file_id = null;
      this.dataForm.template_file = null;
      this.templateFileList = [];
      this.$nextTick(() => {
        if (this.$refs.templateForm) this.$refs.templateForm.validateField("template_file_id");
      });
    },
    handleTemplateFileExceed(files) {
      const file = files && files.length ? files[0] : null;
      if (!file) return;
      this.handleTemplateFileChange({
        name: file.name,
        raw: file,
        size: file.size,
      }, []);
    },
    getContentSummary(content) {
      const body = content && content.body ? content.body : "";
      return body.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    },
    submitForm() {
      this.$refs.templateForm.validate(async (valid) => {
        if (!valid) return;
        const data = MethodService.copyObject(this.dataForm);

        if (this.viewMode === "create") {
          await ContractTemplateConfigApi.create(data);
          window.toastr.success("Thêm mới thành công");
        } else {
          await ContractTemplateConfigApi.update(data);
          window.toastr.success("Cập nhật thành công");
        }

        this.handleClose();
        this.initTable();
      });
    },
    handleClose() {
      this.visibleDialog = false;
      this.viewMode = "create";
      this.dataForm = this.getEmptyForm();
      this.templateFileList = [];
      if (this.$refs.templateForm) this.$refs.templateForm.resetFields();
    },
  },
  async created() {
    await this.loadCategories();
    this.initTable();
  },
};
</script>

<style lang="scss" scoped>
.content-summary {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .template-upload .el-upload,
::v-deep .template-upload .el-upload-dragger {
  width: 100%;
}
</style>
